import React from 'react';
import { ReactComponent as EmptyStateIcon } from 'assets/icons/empty-state.svg';
const EmptyState = () => {
  return (
    <div className='flex justify-center items-center'>
      <div>
        <EmptyStateIcon />
        <p className=' mt-4 text-sm  font-medium text-[#5E6164] mx-auto'>
          You havent created any level
        </p>
      </div>
    </div>
  );
};

export default EmptyState;
